import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const SectionContainer = styled.div`
  background-color: ${tokens.color.neutral_100};
  border-radius: ${tokens.radius.m};
  border: 1px solid ${tokens.color.ui_border_light};
`;
